export default ({ request }) => ({
  resFabricInfoPageList(data = {}) {
    return request({
      url: '/digitalCenter/res/fabric/info/page/list',
      method: 'post',
      data,
    })
  },
  resFabricInfoColorCartList(data = {}) {
    return request({
      url: '/digitalCenter/res/fabric/info/color/cart/list',
      method: 'post',
      data,
    })
  },
  resFabricDemandCommitApi(data = {}) {
    return request({
      url: '/digitalCenter/res/fabric/demand/commit',
      method: 'post',
      data,
    })
  },
  resFabricDemandDetailSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/res/fabric/demand/detail/save',
      method: 'post',
      data,
    })
  },
  resFabricDemandDetailCartListApi(data = {}) {
    return request({
      url: '/digitalCenter/res/fabric/demand/detail/cart/list',
      method: 'post',
      data,
    })
  },
  resFabricDemandDetailDelApi(data = {}) {
    return request({
      url: '/digitalCenter/res/fabric/demand/detail/del',
      method: 'post',
      data,
    })
  },
  resFabricDemandCartCountApi(data = {}) {
    return request({
      url: '/digitalCenter/res/fabric/demand/cart/count',
      method: 'post',
      data,
    })
  },
  resFabricDemandLikeApi(data = {}) {
    return request({
      url: '/digitalCenter/res/fabric/demand/like',
      method: 'post',
      data,
    })
  },
})
